import { useEffect, useMemo } from 'react';
import { useEventCallback } from '@mui/material';
import { type UseQueryResult } from '@tanstack/react-query';

interface UseQueryMonitoringParams {
  queries: UseQueryResult[];
  onStart?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
}
export function useAllQueries(params: UseQueryMonitoringParams) {
  const { queries, onStart, onSuccess, onError } = params;

  const { isLoading, isSuccess, isError } = useMemo(
    () => ({
      isLoading: queries.some((query) => query.isLoading),
      isSuccess: queries.every((query) => query.isSuccess),
      isError: queries.some((query) => query.isError),
    }),
    [queries],
  );

  const handleStart = useEventCallback(() => onStart?.());
  const handleSuccess = useEventCallback(() => onSuccess?.());
  const handleError = useEventCallback(() => onError?.());

  useEffect(() => {
    if (isLoading) handleStart();
    if (isSuccess) handleSuccess();
    if (isError) handleError();
  }, [isLoading, isSuccess, isError, handleStart, handleSuccess, handleError]);
}
